var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewDiscoverCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 18,
    viewBox: "0 0 25 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3438 0.645157H1.41478C0.633417 0.645157 0 1.27942 0 2.06182V16.2284C0 17.0108 0.633417 17.6451 1.41478 17.6451H23.3438C24.1252 17.6451 24.7586 17.0108 24.7586 16.2284V2.06182C24.7586 1.27942 24.1252 0.645157 23.3438 0.645157Z",
    fill: "#FFF3E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.43673 10.0663C4.26362 10.2143 4.04326 10.279 3.69088 10.279H3.54466V8.51279H3.69088C4.04326 8.51279 4.25517 8.57315 4.43673 8.72853C4.62413 8.88909 4.73675 9.13677 4.73675 9.39296C4.73675 9.6504 4.62413 9.9069 4.43673 10.0663ZM3.80004 8.06035H3V10.7317H3.79516C4.21832 10.7317 4.52377 10.6353 4.7915 10.4227C5.10952 10.1709 5.29823 9.79062 5.29823 9.39669C5.29823 8.6081 4.68256 8.06035 3.80004 8.06035Z",
    fill: "#201D1C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.55078 8.06035H6.09328V10.7317H5.55078V8.06035Z",
    fill: "#201D1C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.42621 9.0842C7.09876 8.96928 7.00305 8.89273 7.00305 8.74835C7.00305 8.58053 7.17409 8.45327 7.4093 8.45327C7.57232 8.45327 7.70662 8.51571 7.8497 8.66828L8.13292 8.31273C7.89891 8.11566 7.61882 8.01588 7.31348 8.01588C6.81943 8.01588 6.44288 8.34478 6.44288 8.77968C6.44288 9.14892 6.61793 9.33624 7.12878 9.51412C7.34232 9.58517 7.45082 9.63371 7.50577 9.66659C7.6146 9.73391 7.66879 9.83037 7.66879 9.94187C7.66879 10.1592 7.48886 10.3189 7.24563 10.3189C6.98668 10.3189 6.77716 10.1948 6.65175 9.96189L6.30078 10.2872C6.55171 10.639 6.85249 10.7962 7.26688 10.7962C7.83203 10.7962 8.23026 10.4341 8.23026 9.91843C8.23026 9.49348 8.04556 9.30087 7.42621 9.0842Z",
    fill: "#201D1C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.39844 9.3967C8.39844 10.1823 9.04283 10.791 9.87235 10.791C10.1063 10.791 10.3068 10.7468 10.5537 10.6353V10.0214C10.3355 10.2312 10.144 10.314 9.89619 10.314C9.34806 10.314 8.9598 9.9345 8.9598 9.39297C8.9598 8.88132 9.36063 8.47597 9.87235 8.47597C10.1305 8.47597 10.3278 8.56352 10.5537 8.77645V8.16326C10.3151 8.04782 10.1194 8 9.88351 8C9.05876 8 8.39844 8.62067 8.39844 9.3967Z",
    fill: "#201D1C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.963 9.85378L14.2186 8.06035H13.625L14.8084 10.7991H15.1003L16.3067 8.06035H15.7178L14.963 9.85378Z",
    fill: "#201D1C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5547 10.7317H18.0985V10.279H17.0994V9.55797H18.0606V9.10544H17.0994V8.51278H18.0985V8.06035H16.5547V10.7317Z",
    fill: "#201D1C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1609 9.28874H19.0029V8.48076H19.1698C19.5099 8.48076 19.6922 8.61736 19.6922 8.87759C19.6922 9.14498 19.5099 9.28874 19.1609 9.28874ZM20.2528 8.84852C20.2528 8.34828 19.8942 8.06035 19.2656 8.06035H18.457V10.7317H19.0029V9.65765H19.0737L19.8258 10.7317H20.4956L19.6173 9.60579C20.0277 9.52551 20.2528 9.25729 20.2528 8.84852Z",
    fill: "#201D1C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7034 9.40291C13.7034 10.172 13.0522 10.7954 12.2481 10.7954C11.4443 10.7954 10.793 10.172 10.793 9.40291C10.793 8.63371 11.4443 8.01025 12.2481 8.01025C13.0522 8.01025 13.7034 8.63371 13.7034 9.40291Z",
    fill: "url(#paint0_linear_11307_14147)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7034 9.40291C13.7034 10.172 13.0522 10.7954 12.2481 10.7954C11.4443 10.7954 10.793 10.172 10.793 9.40291C10.793 8.63371 11.4443 8.01025 12.2481 8.01025C13.0522 8.01025 13.7034 8.63371 13.7034 9.40291Z",
    fill: "url(#paint1_radial_11307_14147)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11307_14147",
    x1: 11.3553,
    y1: 8.2734,
    x2: 13.1666,
    y2: 10.4606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6772F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA9D2C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_11307_14147",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.5685 9.98216) rotate(-128.1) scale(1.91083 1.9968)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA9D2C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#DF7624",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.760188,
    stopColor: "#BF4B23",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D3017"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewDiscoverCard);
export default __webpack_public_path__ + "static/media/NewDiscoverCard.0504cfe0.svg";
export { ForwardRef as ReactComponent };